// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_pagination__JgMU9 button, .style_pagination__JgMU9 div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_interface_heading_row__ms0Os {
  display: flex;
  align-items: center;
}

.style_interface_noResults__U2iEh {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_box_heading__-laEF {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.style_box__gVvvt, .style_box_content__DfBtV, .style_interface__ek0bx {
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
}

.style_link__RdTRV {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__RdTRV:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__-EuWX {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__jAqdx {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__K68mJ, .style_interface_heading__Mpygw, .style_interface_footer__cUju6 {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__-i3\\+8 {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__Vr18L {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__Vr18L {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__Btuho {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__Btuho {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__Tn1o1 {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__Tn1o1 {
    line-height: 1.5rem;
  }
}

.style_breadcumb__Pgyhb {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__Pgyhb a,
.style_breadcumb__Pgyhb span {
  padding: 3px 5px;
}
.style_breadcumb__Pgyhb a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__Pgyhb a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__Pgyhb .style_divider__k-tUU {
  color: var(--color-gray-400);
}

.style_badge__7u5y8 {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__7u5y8.style_xs__\\+9sJo {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__7u5y8.style_sm__hVTWg {
  padding: 4px 7px;
}
.style_badge__7u5y8.style_primary__JtzPk {
  background: var(--color-primary-500);
}
.style_badge__7u5y8.style_primary__JtzPk, .style_badge__7u5y8.style_pm__Jab6X {
  background: var(--color-primary-500);
}
.style_badge__7u5y8.style_sd__lkvdM {
  background-color: var(--color-secundary-500);
}
.style_badge__7u5y8.style_Likely__-n9wB {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__7u5y8.style_Unvalidated__sEm9y {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__7u5y8.style_Verified__bXSRj, .style_badge__7u5y8.style_green__vPA2b {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__7u5y8.style_off__M39Au {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__DIpXp {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__DIpXp.style_xs__\\+9sJo {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__DIpXp.style_sm__hVTWg {
  padding: 4px 7px;
}
.style_badgeTable__DIpXp.style_primary__JtzPk, .style_badgeTable__DIpXp.style_pm__Jab6X {
  background: var(--color-primary-500);
}
.style_badgeTable__DIpXp.style_sd__lkvdM {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__DIpXp.style_Likely__-n9wB {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__DIpXp.style_Verified__bXSRj, .style_badgeTable__DIpXp.style_green__vPA2b {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__DIpXp.style_off__M39Au {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__r4-vf {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__r4-vf.style_style-1__eUnqP td,
.style_table__r4-vf.style_style-1__eUnqP th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__r4-vf.style_style-1__eUnqP th,
.style_table__r4-vf.style_style-1__eUnqP td.style_label__PAbX2 {
  color: var(--color-white-500);
}
.style_table__r4-vf.style_style-1__eUnqP th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__r4-vf.style_style-1__eUnqP tr.style_noBorder__3SpPT td {
  border-bottom: none;
}
.style_table__r4-vf.style_style-1__eUnqP tr td {
  color: var(--color-white-500);
}

.style_pagination__JgMU9 {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__JgMU9 button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__JgMU9 button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__JgMU9 button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__JgMU9 button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__JgMU9 button.style_disabled__AHwfr, .style_pagination__JgMU9 button.style_active__4ovjH, .style_pagination__JgMU9 button.style_info__OSxj7 {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__JgMU9 button.style_disabled__AHwfr {
  color: var(--color-gray-700);
}
.style_pagination__JgMU9 div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__JgMU9 div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__JgMU9 div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__JgMU9 div:hover, .style_pagination__JgMU9 div.style_active__4ovjH {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__JgMU9 div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__JgMU9 div.style_disabled__AHwfr, .style_pagination__JgMU9 div.style_active__4ovjH, .style_pagination__JgMU9 div.style_info__OSxj7 {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__JgMU9 div.style_disabled__AHwfr {
  color: var(--color-gray-700);
}
.style_pagination__JgMU9 div:last-child, .style_pagination__JgMU9 div:first-child {
  padding: 0 10px;
}
.style_pagination__JgMU9 div:last-child {
  border-right: none;
}
.style_pagination__JgMU9 button:last-child, .style_pagination__JgMU9 button:first-child {
  padding: 0 10px;
}
.style_pagination__JgMU9 button:last-child {
  border-right: none;
}

.style_interface__ek0bx {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__Mpygw {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__Mpygw {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__Mpygw > div {
    width: 100%;
  }
}
.style_interface_heading_row__ms0Os {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__ms0Os {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__cUju6 {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__cUju6 {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__cUju6 > div {
    width: 100%;
  }
}
.style_interface_foot__x6kNI {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__x6kNI {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__U2iEh {
  gap: 15px;
  padding: 70px 0;
}

.style_box__gVvvt {
  width: 100%;
  gap: 20px;
}
@media only screen and (max-width: 780px) {
  .style_box_heading__-laEF {
    width: 100%;
    justify-content: flex-start;
  }
}
.style_box_heading_input__PC\\+xq {
  width: 216px !important;
  border-radius: 8px;
}
.style_box_heading_input__PC\\+xq input {
  padding: 5px 0 !important;
  color: var(--text-color-W);
}
.style_box_heading_input__PC\\+xq input::placeholder {
  color: var(--text-color-W);
}
@media only screen and (max-width: 780px) {
  .style_box_heading_input__PC\\+xq {
    display: none;
  }
}
.style_box_heading_text__URM85 {
  color: white;
  font-size: 24px;
  font-weight: 500;
}
.style_box_content_tabs__Hdfml {
  display: flex;
  align-items: center;
}
.style_box_content_tabs_tab__gRHiu {
  padding: 8px 12px;
  border-radius: 8px 8px 0px 0px;
  color: var(--color-white-500);
  cursor: pointer;
  margin-right: 8px;
}
.style_box_content_tabs_tab_active__LdAOL {
  background-color: var(--dark-bg);
  color: var(--text-color-W);
}
@media only screen and (max-width: 780px) {
  .style_box_content_tabs_tab_active__LdAOL {
    border-radius: 28px;
  }
  .style_box_content_tabs_tab__gRHiu {
    margin-bottom: 16px;
  }
  .style_box_content_tabs__Hdfml {
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
  }
  .style_box_content_tabs__Hdfml::-webkit-scrollbar {
    display: none;
  }
}
.style_box_content_forms__J\\+ofb {
  background-color: var(--dark-bg);
  padding: 32px 24px;
  border-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_box_content_forms__J\\+ofb {
    padding: 14px;
  }
}
.style_box_content_forms_firstActive__P28Kv {
  border-radius: 0px 8px 8px 8px !important;
}
@media only screen and (max-width: 780px) {
  .style_box_content_forms_firstActive__P28Kv {
    border-radius: 8px !important;
  }
}

.style_form_oneinput__eLsRm {
  display: flex;
  align-items: center;
  gap: 15px;
  /* Chrome, Safari, Edge, Opera */
  /* Firefox */
}
.style_form_oneinput__eLsRm input::-webkit-outer-spin-button,
.style_form_oneinput__eLsRm input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.style_form_oneinput__eLsRm input[type=number] {
  -moz-appearance: textfield;
}
@media only screen and (max-width: 450px) {
  .style_form_oneinput__eLsRm {
    gap: 15px;
    min-width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
}
@media only screen and (max-width: 576px) {
  .style_form_table__lkf\\+P {
    overflow-x: scroll !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_flex.scss","webpack://./src/components/modules/Lead/Form/style.module.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss","webpack://./src/assets/scss/_colors.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;ACCF;;ADaA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACVF;;ADkBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACfF;;ADuBA;EACE,aAAA;EACA,sBAAA;ACpBF;;ACnBA;EACI,qBAAA;ADsBJ;;ACpBA;EACI,eAAA;EACA,cAAA;ADuBJ;ACtBI;EACE,0BAAA;ADwBN;;ACpBA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ADuBJ;;ACpBI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ADuBR;ACrBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ADuBR;ACrBI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ADuBR;ACrBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADuBR;AE/DE;EDsCE;IAIQ,eAAA;IACA,mBAAA;EDyBV;AACF;ACvBI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADyBR;AEzEE;ED8CE;IAIQ,eAAA;IACA,mBAAA;ED2BV;AACF;ACzBI;EACI,mBAAA;AD2BR;AElFE;EDsDE;IAGQ,mBAAA;ED6BV;AACF;;AGrFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AHwFF;AGvFE;;EAEE,gBAAA;AHyFJ;AGvFE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AHyFJ;AGxFI;EACE,+BAAA;EACA,uCAAA;AH0FN;AGvFE;EACE,4BAAA;AHyFJ;;AI7GA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJgHF;AI7GE;EACE,gBAAA;EACA,eAAA;AJ+GJ;AI7GE;EACE,gBAAA;AJ+GJ;AI3GE;EACE,oCAAA;AJ6GJ;AI3GE;EAEE,oCAAA;AJ4GJ;AI1GE;EACE,4CAAA;AJ4GJ;AI1GE;EACE,uCAAA;EACA,mCAAA;AJ4GJ;AI1GE;EACE,oCAAA;EACA,gCAAA;AJ4GJ;AI1GE;EAEE,4CAAA;EACA,kCAAA;AJ2GJ;AIzGE;EACE,6BAAA;EACA,uCAAA;AJ2GJ;;AIxGA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJ2GF;AIxGE;EACE,gBAAA;EACA,eAAA;AJ0GJ;AIxGE;EACE,gBAAA;AJ0GJ;AItGE;EAEE,oCAAA;AJuGJ;AIrGE;EACE,4CAAA;AJuGJ;AIrGE;EACE,mBAAA;EACA,cAAA;AJuGJ;AIrGE;EAEE,4CAAA;EACA,kCAAA;AJsGJ;AIpGE;EACE,6BAAA;EACA,uCAAA;AJsGJ;;AK9LA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;ALiMF;AK/LI;;EAEE,kBAAA;EACA,mBAAA;ALiMN;AK/LI;;EAEE,6BAAA;ALiMN;AK/LI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;ALiMN;AK9LM;EACE,mBAAA;ALgMR;AK9LM;EACE,6BAAA;ALgMR;;AMpNA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;ANsNJ;AMpNI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANqNR;AMpNQ;EACI,2BAAA;EACA,8BAAA;ANsNZ;AMpNQ;EACI,4BAAA;EACA,+BAAA;ANsNZ;AErPE;EIgBE;IAkBQ,eAAA;IACA,eAAA;ENuNV;AACF;AMtNQ;EACI,eAAA;EACA,oBAAA;ANwNZ;AMtNQ;EACI,4BAAA;ANwNZ;AMrNI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANsNR;AMrNQ;EACI,2BAAA;EACA,8BAAA;ANuNZ;AMrNQ;EACI,4BAAA;EACA,+BAAA;ANuNZ;AMrNQ;ECrCJ,eAAA;EACA,qFAAA;AP6PJ;AEvRE;EI6CE;IAqBQ,eAAA;IACA,eAAA;ENyNV;AACF;AMxNQ;EACI,eAAA;EACA,oBAAA;AN0NZ;AMxNQ;EACI,4BAAA;AN0NZ;AMvNI;EACI,eAAA;ANyNR;AMvNI;EACI,kBAAA;ANyNR;AMvNI;EACI,eAAA;ANyNR;AMvNI;EACI,kBAAA;ANyNR;;AQ3SA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;AR8SF;AQ5SE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AR6SJ;AErUE;EMeA;IAWI,kBAAA;IACA,uBAAA;ER+SJ;EQ9SI;IACE,WAAA;ERgTN;AACF;AQ9SI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;AR+SN;AEnVE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ERiTN;AACF;AQ9SE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AR+SJ;AEnWE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ERiTJ;EQhTI;IACE,WAAA;ERkTN;AACF;AQ/SE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;ARiTJ;AEjXE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ERmTJ;AACF;AQjTE;EAEE,SAAA;EACA,eAAA;ARkTJ;;AA3XA;EACE,WAAA;EAEA,SAAA;AA6XF;AExWE;EFlBA;IAII,WAAA;IACA,2BAAA;EA0XJ;AACF;AAxXI;EACE,uBAAA;EACA,kBAAA;AA0XN;AAzXM;EACE,yBAAA;EACA,0BSLO;ATgYf;AAzXQ;EACE,0BSRK;ATmYf;AEzXE;EFVE;IAYI,aAAA;EA2XN;AACF;AAxXI;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AA0XN;AAjXI;EACE,aAAA;EACA,mBAAA;AAmXN;AAjXM;EACE,iBAAA;EACA,8BAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AAmXR;AAjXQ;EACE,gCSpDA;ETqDA,0BSzCK;AT4Zf;AElZE;EF6BM;IAKI,mBAAA;EAoXV;EAhYI;IAiBI,mBAAA;EAoXR;EAzYE;IA0BI,mBAAA;IACA,kBAAA;IACA,kBAAA;EAoXN;EAlXM;IACE,aAAA;EAoXR;AAdF;AAhWI;EACE,gCS9EI;ET+EJ,kBAAA;EACA,kBAAA;AAiXN;AEncE;EF+EE;IAKI,aAAA;EAmXN;AACF;AAlXM;EACE,yCAAA;AAoXR;AEnbE;EF8DI;IAII,6BAAA;EAqXR;AACF;;AA9WE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,gCAAA;EAOA,YAAA;AA0WJ;AAhXI;;EAEE,wBAAA;EACA,SAAA;AAkXN;AA9WI;EACE,0BAAA;AAgXN;AEheE;EFkGA;IAkBI,SAAA;IACA,eAAA;IACA,sBAAA;IACA,uBAAA;EAgXJ;AACF;AEtdE;EFyGA;IAEI,6BAAA;EA+WJ;AACF","sourcesContent":["%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"/src/assets/scss/\" as *;\n.box {\n  width: 100%;\n  @extend %flex-column;\n  gap: 20px;\n\n  // Heading Part\n  &_heading {\n    @extend %flex-justify-between-center;\n\n    @include middleTablet {\n      width: 100%;\n      justify-content: flex-start;\n    }\n\n    &_input {\n      width: 216px !important;\n      border-radius: 8px;\n      input {\n        padding: 5px 0 !important;\n        color: $text-color-W;\n\n        &::placeholder {\n          color: $text-color-W;\n        }\n      }\n      @include middleTablet {\n        display: none;\n      }\n    }\n\n    &_text {\n      color: white;\n      font-size: 24px;\n      font-weight: 500;\n    }\n  }\n\n  // Box Content\n  &_content {\n    @extend %flex-column;\n\n    // Tabs part\n    &_tabs {\n      display: flex;\n      align-items: center;\n      //Each tab\n      &_tab {\n        padding: 8px 12px;\n        border-radius: 8px 8px 0px 0px;\n        color: var(--color-white-500);\n        cursor: pointer;\n        margin-right: 8px;\n\n        &_active {\n          background-color: $dark-bg;\n          color: $text-color-W;\n\n          @include middleTablet {\n            border-radius: 28px;\n          }\n        }\n\n        @include middleTablet {\n          margin-bottom: 16px;\n        }\n      }\n\n      @include middleTablet {\n        white-space: nowrap;\n        overflow-x: scroll;\n        overflow-y: hidden;\n\n        &::-webkit-scrollbar {\n          display: none;\n        }\n      }\n    }\n\n    //Box Forms\n    &_forms {\n      background-color: $dark-bg;\n      padding: 32px 24px;\n      border-radius: 8px;\n      @include mobile {\n        padding: 14px;\n      }\n      &_firstActive {\n        border-radius: 0px 8px 8px 8px !important;\n\n        @include middleTablet {\n          border-radius: 8px !important;\n        }\n      }\n    }\n  }\n}\n\n.form {\n  &_oneinput {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n\n    /* Chrome, Safari, Edge, Opera */\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n\n    /* Firefox */\n    input[type=\"number\"] {\n      -moz-appearance: textfield;\n    }\n    \n    @include mobile {\n      gap: 15px;\n      min-width: 100%;\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n\n  &_table {\n    @include middle {\n      overflow-x: scroll !important;\n    }\n  }\n}","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}","//Global colors\n$main-color: var(--main-color);\n$bg-color: var(--bg-color);\n$dark-bg: var(--dark-bg);\n$body-bg: var(--body-bg);\n$error-color: var(--error-color);\n\n$color-gradient-black-500: var(--color-gradient-black-500);\n$color-gradient-black-200: var(--color-gradient-black-200);\n\n//Gradient\n$gradient: var(--gradient);\n$gradient-border: var(--gradient-border);\n\n//text-colors\n$text-color-W: var(--text-color-W);\n\n//border\n$border: var(--border);\n\n//scrollbar\n$scrollbar-background: var(--scrollbar-background);\n$scrollbar-hover-color: var(--scrollbar-hover-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `style_pagination__JgMU9`,
	"interface_heading_row": `style_interface_heading_row__ms0Os`,
	"interface_noResults": `style_interface_noResults__U2iEh`,
	"box_heading": `style_box_heading__-laEF`,
	"box": `style_box__gVvvt`,
	"box_content": `style_box_content__DfBtV`,
	"interface": `style_interface__ek0bx`,
	"link": `style_link__RdTRV`,
	"text-gradient-intel": `style_text-gradient-intel__-EuWX`,
	"text-xs": `style_text-xs__jAqdx`,
	"text-sm": `style_text-sm__K68mJ`,
	"interface_heading": `style_interface_heading__Mpygw`,
	"interface_footer": `style_interface_footer__cUju6`,
	"text-base": `style_text-base__-i3+8`,
	"text-lg": `style_text-lg__Vr18L`,
	"text-xl": `style_text-xl__Btuho`,
	"text-leading": `style_text-leading__Tn1o1`,
	"breadcumb": `style_breadcumb__Pgyhb`,
	"divider": `style_divider__k-tUU`,
	"badge": `style_badge__7u5y8`,
	"xs": `style_xs__+9sJo`,
	"sm": `style_sm__hVTWg`,
	"primary": `style_primary__JtzPk`,
	"pm": `style_pm__Jab6X`,
	"sd": `style_sd__lkvdM`,
	"Likely": `style_Likely__-n9wB`,
	"Unvalidated": `style_Unvalidated__sEm9y`,
	"Verified": `style_Verified__bXSRj`,
	"green": `style_green__vPA2b`,
	"off": `style_off__M39Au`,
	"badgeTable": `style_badgeTable__DIpXp`,
	"table": `style_table__r4-vf`,
	"style-1": `style_style-1__eUnqP`,
	"label": `style_label__PAbX2`,
	"noBorder": `style_noBorder__3SpPT`,
	"disabled": `style_disabled__AHwfr`,
	"active": `style_active__4ovjH`,
	"info": `style_info__OSxj7`,
	"interface_foot": `style_interface_foot__x6kNI`,
	"box_heading_input": `style_box_heading_input__PC+xq`,
	"box_heading_text": `style_box_heading_text__URM85`,
	"box_content_tabs": `style_box_content_tabs__Hdfml`,
	"box_content_tabs_tab": `style_box_content_tabs_tab__gRHiu`,
	"box_content_tabs_tab_active": `style_box_content_tabs_tab_active__LdAOL`,
	"box_content_forms": `style_box_content_forms__J+ofb`,
	"box_content_forms_firstActive": `style_box_content_forms_firstActive__P28Kv`,
	"form_oneinput": `style_form_oneinput__eLsRm`,
	"form_table": `style_form_table__lkf+P`
};
export default ___CSS_LOADER_EXPORT___;
